import { container } from '@shared/common/dependency-injection/domain/container';
import { GameDetailModuleRoutes } from '@client/feature/game-detail/application/routes/game-detail.module-routes';

export const gameDetailRoutes = new GameDetailModuleRoutes(container).getRoutes();
